<template>
  <div
    ref="newTargetModalRef"
    class="modal fade"
    id="add-img-modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      style="max-width: 450px"
    >
      <div
        class="modal-content"
        style="background: transparent; box-shadow: none"
      >
        <div class="h-550px">
          <img
            id="image"
            v-if="!controlVideo(props.imgObj.Url)"
            :src="imgObj.Url"
            alt="image"
            style="
              border-radius: 10px 10px 0 0;
              height: 100%;
              width: 100%;
              background-color: white;
              object-fit: cover;
            "
          />
          <video
            v-else
            :id="`video-${props.imgObj.Id}`"
            controls
            style="height: 100%; width: 100%; object-fit: cover; background-color: black"
          >
            <source :src="props.imgObj.Url" />
          </video>
        </div>

        <div
          class="m-0 d-flex bg-white"
          style="border-radius: 0 0 10px 10px !important"
        >
          <button
            class="btn btn-danger col-lg-6 rounded-0 w-50"
            style="border-radius: 0 0 0 10px !important ; flex: 1/2"
            @click="removeImg(imgObj.Id)"
          >
            <i class="bi bi-trash-fill fs-5 text-white"></i>
            {{
              !controlVideo(props.imgObj.Url)
                ? translate("audit_report_delete_photo")
                : translate("audit_report_delete_video")
            }}
          </button>

          <button
            @click="onDownload(props.imgObj.Url)"
            class="btn btn-light col-lg-6 rounded-0 w-50"
            style="border-radius: 0 0 10px 0 !important ; flex: 1/2"
          >
            <i class="fw-bolder bi bi-arrow-right fs-5 text-dark"></i>
            <span class="text-dark">
              {{
                !controlVideo(props.imgObj.Url)
                  ? translate("edit_answer_open_photo")
                  : translate("edit_answer_open_video")
              }}</span
            >
          </button>
        </div>

        <button
          @click="hideModalFunction()"
          class="position-absolute bottom-90 start-100 translate-middle badge bg-white rounded-circle p-3 border shadow-sm"
        >
          <i class="bi bi-x-lg text-gray-700 fs-3"></i>
        </button>

        <!-- <canvas id="canvas"></canvas> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, provide, onMounted, watch, defineProps, defineEmits } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import axios from "axios";

const store = useStore();

const props = defineProps({ imgObj: Object, auditId: Number });
const emit = defineEmits(["removeImg"]);
const newTargetModalRef = ref(null);

//Çoklu dil tanımalamas
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

//Video olup olmadığı kontrolü
const controlVideo = (path, a) => {
  if (path != null) {
    const middlePath = path.substring(path.length - 3);
    if (middlePath == "mp4") {
      return true;
    } else {
      return false;
    }
  }
};

//Fotoğraf Silme
const removeImg = (imgId) => {
  const obj = {
    imgId: imgId,
    auditId: props.auditId,
  };
  if (confirm(translate("confirm_message_img"))) {
    store.dispatch("AuditReportModule/REMOVE_IMG", obj).then((response) => {
      hideModalFunction();
      emit("removeImg");
    });
  }
};

const onDownload = async (url) => {
  window.open(url, "_blank");
};

const getimgBase64 = (url, callback) => {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
};

//Image Modal gizleme
const hideModalFunction = () => {
  hideModal(newTargetModalRef.value);
};

const videoPause = () => {
  const vid = document.getElementById(`video-${props.imgObj.Id}`);
  if (vid) {
    vid.pause();
    vid.currentTime = 0;
  }
};

onMounted(() => {
  document.getElementById("add-img-modal").addEventListener("hide.bs.modal", function () {
    videoPause();
  });
});
</script>
